import React from "react";
import { Button } from "primereact/button";
import ModalBase from "./ModalBase";
import PropTypes from "prop-types";

// Specialized modal for form-based interactions
const FormModal = ({
  children,
  title,
  visible,
  onHide,
  onSave,
  onCancel,
  saveLabel = "Salvar",
  cancelLabel = "Cancelar",
  saveIcon = "pi pi-check",
  cancelIcon = "pi pi-times",
  isLoading = false,
  size = "medium",
  extraActions,
  className = "",
  ...props
}) => {
  const footer = (
    <div
      className="modal-footer"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div style={{ display: "flex", gap: "4px" }}>{extraActions}</div>
      <div style={{ display: "flex", gap: "6px" }}>
        <Button
          label={cancelLabel}
          icon={cancelIcon}
          onClick={onCancel || onHide}
          className="p-button-text p-button-sm"
          disabled={isLoading}
          data-evo-id="formmodal-btn-cancel"
        />
        <Button
          label={saveLabel}
          icon={saveIcon}
          onClick={onSave}
          className="p-button-success p-button-sm"
          disabled={isLoading}
          data-evo-id="formmodal-btn-save"
        />
      </div>
    </div>
  );

  return (
    <ModalBase
      header={title}
      visible={visible}
      onHide={onHide}
      footer={footer}
      size={size}
      variant="form"
      className={`${isLoading ? "modal-loading" : ""} ${className}`.trim()}
      {...props}
    >
      {children}
    </ModalBase>
  );
};

FormModal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  saveLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  saveIcon: PropTypes.string,
  cancelIcon: PropTypes.string,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large", "full"]),
  extraActions: PropTypes.node,
  className: PropTypes.string,
  onBeforeHide: PropTypes.func,
};

export default FormModal;
